<template>
  <!-- 按钮文字
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item label="按钮文字"> 
      <el-input v-model="buttonText" 
                placeholder='请输入按钮文字'></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 按钮文字
     *  @description 将 buttonText 字段映射到当前 buttonText 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    ...mapComputed({
      buttonText: { 
        parent: i => i.baseOption,
        attr: "buttonText" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingButtonText.vue